import type { FC, ReactNode } from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

import {
  selectAccessToken,
  selectPermissions,
  selectUser,
} from "@/app/auth/auth.slice";
import { Permission, usePermission } from "@/shared/hooks/usePermission";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export type AuthorizedRouteProps = {
  children?: ReactNode;
  permission: Permission;
};

export const AuthorizedRoute: FC<AuthorizedRouteProps> = ({
  children,
  permission,
}) => {
  const accessToken = useSelector(selectAccessToken);
  const storedAccessToken = localStorage.getItem("accessToken");
  const permissions = useSelector(selectPermissions);
  const { can } = usePermission();
  const user = useSelector(selectUser);

  const hasToken = accessToken || storedAccessToken;
  const permissionsLoaded = permissions && permissions.length > 0;
  const hasPermission = hasToken && permissionsLoaded && can(permission);

  if (hasToken && !permissionsLoaded) {
    return (
      <div className="flex justify-center items-center h-screen w-screen">
        <FontAwesomeIcon icon={faSpinner} spin className="text-6xl" />
      </div>
    );
  }

  // Si no tiene permiso, redirigir a su branch específico o a una ruta segura
  if (!hasPermission) {
    const fallbackPath = user?.branch?.id
      ? `/branchs/${user.branch.id}`
      : "/users"; // O cualquier otra ruta segura por defecto
    return <Navigate to={fallbackPath} replace />;
  }

  return children;
};
